import firebase from 'firebase/app';

import { SESSION_STARTED, SESSION_FINISHED } from '@/store/session/actionTypes';

export default (store) => {
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      store.dispatch(SESSION_STARTED, user);
    } else {
      store.dispatch(SESSION_FINISHED);
    }
  });
};
